import { MenuItem } from '@mui/material';
import styled from '@emotion/styled';

export const StyedMenuItem = styled(MenuItem)({
  fontWeight : '500 !important',
});
